export const LoanActionCreators = {
  setLoading: (state) => ({ type: "CHANGE_LOADING", payload: state }),
  setLoanAmount: (amount) => ({ type: "CHANGE_LOAN_AMOUNT", payload: amount }),
  setRefundAmount: (amount) => ({
    type: "CHANGE_REFUND_AMOUNT",
    payload: amount,
  }),
  setOverpaymentAmount: (amount) => ({
    type: "CHANGE_OVERPAYMENT_AMOUNT",
    payload: amount,
  }),
  setTermAmount: (term) => ({ type: "CHANGE_TERM_AMOUNT", payload: term }),
  setPeriodType: (period) => ({ type: "CHANGE_PERIOD_TYPE", payload: period }),
  setPaymentAmount: (amount) => ({
    type: "CHANGE_PAYMENT_AMOUNT",
    payload: amount,
  }),
};

export const AuthActionCreators = {
  setIsLoading: (isLoading) => ({ type: "SET_IS_LOADING", payload: isLoading }),
  setAuthData: (data) => ({ type: "SET_AUTH_DATA", payload: data }),
  setAuthErrors: (errors) => ({ type: "SET_AUTH_ERRORS", payload: errors }),
  setContactId: (id) => ({ type: "SET_CONTACT_ID", payload: id }),
  setApplicationId: (id) => ({ type: "SET_APPLICATION_ID", payload: id }),
  setIsAuth: (id) => ({ type: "SET_IS_AUTH", payload: id }),
  setAnononymousId: (id) => ({ type: "SET_ANONYMOUS_ID", payload: id }),
  setCodeId: (id) => ({ type: "SET_AUTH_CODE_ID", payload: id }),
  setCodeExpires: (expires) => ({
    type: "SET_AUTH_CODE_EXPIRES",
    payload: expires,
  }),
  setIsFirstApplication: (flag) => ({
    type: "SET_IS_FIRST_APPLICATION",
    payload: flag,
  }),
  setIsNewClient: (flag) => ({
    type: "SET_IS_NEW_CLIENT",
    payload: flag,
  }),
  setIsShortForm: (flag) => ({
    type: "SET_IS_SHORT_FORM",
    payload: flag,
  }),
};

export const RegistrationActionCreators = {
  setIsLoading: (isLoading) => ({ type: "SET_IS_LOADING", payload: isLoading }),
  setUserData: (data) => ({ type: "SET_USER_DATA", payload: data }),
  setRegistrationCodes: (data) => ({ type: "SET_CODES", payload: data }),
  setRegistrationErrors: (errors) => ({
    type: "SET_REGISTRATION_ERRORS",
    payload: errors,
  }),
  setDefaultCalculatorSettings: (settings) => ({
    type: "SET_DEFAULT_CALCULATOR_SETTINGS",
    payload: settings,
  }),
};

export const NewFormActionCreators = {
  setErrors: (errors) => ({ type: "SET_ERRORS", payload: errors }),
  setResult: (result) => ({ type: "SET_RESULT", payload: result }),
  setIsPassport: (isPassport) => ({
    type: "SET_IS_PASSPORT",
    payload: isPassport,
  }),
  setIsAddress: (isAddress) => ({ type: "SET_IS_ADDRESS", payload: isAddress }),
  setIsWork: (isWork) => ({ type: "SET_IS_WORK", payload: isWork }),
  setCalculatorSettings: (result) => ({
    type: "SET_CALCULATOR_SETTINGS",
    payload: result,
  }),
  addBankAccountSuccess: (result) => ({
    type: "ADD_BANK_ACCOUNT_SUCCESS",
    payload: result,
  }),
  addWalletSuccess: (result) => ({
    type: "ADD_WALLET_SUCCESS",
    payload: result,
  }),
  setCompletions: (key, completions) => ({
    type: "SET_COMPLETIONS",
    payload: { key, completions },
  }),
  setApplicationId: (id) => ({ type: "SET_APPLICATION_ID", payload: id }),
  setDictionaries: (result) => ({ type: "SET_DICTIONARIES", payload: result }),
  setAdditionalQuestionsDictionary: (dictionary) => ({
    type: "SET_ADDITIONAL_QUESTIONS_DICTIONARY",
    payload: dictionary,
  }),
  setProductId: (id) => ({ type: "SET_PRODUCT_ID", payload: id }),
};

export const ProgressBarCreators = {
  setPercent: (options) => ({ type: "SET_PERCENT", payload: options }),
};

export const FormDataCreators = {
  setPassportData: (data) => ({ type: "SET_PASSPORT_DATA", payload: data }),
  setAddressData: (data) => ({ type: "SET_ADDRESS_DATA", payload: data }),
  setWorkData: (data) => ({ type: "SET_WORK_DATA", payload: data }),
};

export { LoadersActionCreators } from "./loadersActions";

export const resetAction = {
  type: "RESET",
};
